<template>
  <div class="animated fadeIn">
    <h1 class="title">Integración con Strava</h1>
    <b-row
      ><b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <i class="icon-link"></i> Integrar con Strava
          </b-card-header>
          <b-card-body>
            <pulse-loader
              v-if="loading"
              :loading="loading"
              color="white"
              size="10px"
            ></pulse-loader>

            <div v-else-if="!stravaUser">
              <p class="mb-2">
                Sincroniza todos tus entrenamientos con Strava de forma
                automática. Para empezar, solo tienes que vincular tu usuario
                con MyBodytone desde el siguiente enlace:
              </p>
              <a :href="oauthLink"
                ><img
                  class="navbar-brand-full"
                  src="../assets/stravalogo.png"
                  height="35"
                  alt="Strava logo"
              /></a>
            </div>
            <div v-else>
              <p class="mb-2">
                Sincronización con Strava activada correctamente. Tus sesiones se sincronizarán automáticamente a partir de ahora. 
              </p>
              <b-button variant="danger" v-on:click="deleteStravaUser"
                >Desvincular cuenta</b-button
              >
            </div>
          </b-card-body>
        </b-card></b-col
      ></b-row
    >
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "Strava",
  components: {
    PulseLoader,
  },
  data() {
    return {
      //need to extract client_id, redirect_uri and scope to a constants file
      oauthLink:
        "http://www.strava.com/oauth/authorize?client_id=56033&response_type=code&redirect_uri=https://mybodytone.eu/strava&approval_prompt=force&scope=activity:write",
      stravaauth: {
        code: null,
        scope: null,
      },
      stravaUser: false,
      loading: true,
    };
  },
  async mounted() {
    if (await this.getUserStravaInfo()) {
      this.loading = false;
      return;
    }

    if (this.$route.query.error) {
      //TODO show error
      console.log(`error: ${this.$route.query.error}`);
      this.loading = false;

      return;
    }

    if (this.$route.query.code) {
      Object.assign(this.stravaauth, this.$route.query);
      if (this.stravaauth.scope != "read,activity:write") {
        //TODO show error: lack of permissions
        this.loading = false;

        console.log("error: lack of permissions");
        return;
      } else {
        console.log("calling function");
        this.$store
          .dispatch("savestravatokens", { stravaauth: this.stravaauth })
          .then(
            (response) => {
              this.stravaUser = true;
              this.loading = false;
            },
            (error) => {
              console.log(error);
              // this.showErrorMsg({message: error});
              this.loading = false;
            }
          )
          .catch((err) => {
            console.log(err);
          });
      }
    } else {this.loading = false;}
  },
  methods: {
    getUserStravaInfo() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("getUserStravaInfo")
          .then((response) => {
            this.stravaUser = response;

            console.log(response);
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteStravaUser() {
      this.loading = true;

      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("deletestravatokens")
          .then((response) => {
            this.stravaUser = false;
            this.loading = false;

            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Strava.vue